import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import Tx120FeatureRow from './Tx120FeatureRow';
import { FeatureSurveyModalHeader } from '../featureSurvey/FeatureSurveyModalHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TX120BaseSurveyModal = ({
  headline,
  renderModalFooter,
  allFeatures,
  setSelectedFeatures,
  isOtherSelected,
  setIsOtherSelected
}) => {
  const featureKeys = Object.keys(allFeatures);
  const handleSelectedFeatureChange = (featureKey, isSelected) => {
    if (featureKey === 'other') {
      setIsOtherSelected(isSelected);
      return;
    }
    const newSelectedFeatures = Object.assign({}, allFeatures, {
      [featureKey]: isSelected
    });
    setSelectedFeatures(newSelectedFeatures);
  };
  const renderTwoRows = () => {
    const firstRowFeatureKeys = featureKeys.slice(0, 3);
    const secondRowFeatures = featureKeys.slice(3);
    secondRowFeatures.push('other');
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Tx120FeatureRow, {
        className: "m-bottom-5",
        survey: allFeatures,
        featureKeys: firstRowFeatureKeys,
        onSelectionChange: handleSelectedFeatureChange
      }, 1), /*#__PURE__*/_jsx(Tx120FeatureRow, {
        survey: allFeatures,
        featureKeys: secondRowFeatures,
        isOtherSelected: isOtherSelected,
        onSelectionChange: handleSelectedFeatureChange
      }, 2)]
    });
  };
  const renderThreeRows = () => {
    const firstRowFeatureKeys = featureKeys.slice(0, 3);
    const secondRowFeatures = featureKeys.slice(3);
    const lastRow = ['other'];
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Tx120FeatureRow, {
        className: "m-bottom-5",
        survey: allFeatures,
        featureKeys: firstRowFeatureKeys,
        onSelectionChange: handleSelectedFeatureChange
      }, 1), /*#__PURE__*/_jsx(Tx120FeatureRow, {
        className: "m-bottom-5",
        survey: allFeatures,
        featureKeys: secondRowFeatures,
        onSelectionChange: handleSelectedFeatureChange
      }, 2), /*#__PURE__*/_jsx(Tx120FeatureRow, {
        className: "m-bottom-8",
        survey: allFeatures,
        featureKeys: lastRow,
        isOtherSelected: isOtherSelected,
        onSelectionChange: (__key, value) => setIsOtherSelected(value)
      }, 3)]
    });
  };
  const renderFeatureRows = () => {
    // Render 3 rows of box buttons if there are 6 features for that api name.
    if (featureKeys.length === 6) {
      return renderThreeRows();
    }
    return renderTwoRows();
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "success",
    width: 600,
    size: "auto",
    centered: true,
    children: [/*#__PURE__*/_jsx(FeatureSurveyModalHeader, {}), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx("p", {
        className: "text-center",
        style: {
          fontWeight: 'bold'
        },
        children: headline || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.trialFeatureSurvey.common.headline"
        })
      }), renderFeatureRows()]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: renderModalFooter('m-all-0 m-top-2')
    })]
  });
};
export default TX120BaseSurveyModal;